import DataController from '../domain/controller'

async function getSingleData(dataKey, filters, context) {
  const { networkRepo, sendBugAlert } = context
  try {
    return DataController.getSingleData(dataKey, filters, networkRepo)
  } catch (error) {
    console.log('🚀 ~ getSingleData ~ error:', error)
    sendBugAlert(error)
    return null
  }
}

export default getSingleData
